import { isDevPreview } from '../boot/devPreview';
import { sb } from './supabase';

/**
 * ONE 플랫폼 지점마스터 (통합표준 9절) — 읽기 전용.
 *
 * `public.branches` 는 이 시스템이 만든 테이블이 아니다. ONE 플랫폼 관리자페이지의
 * "지점 관리" 탭에서 전 시스템이 공유하는 마스터라, 여기서는 SELECT 만 한다
 * (RLS 가 로그인한 사람 누구나 조회는 허용해 둬서 별도 RPC·서비스키가 필요 없다).
 * 쓰기(추가·수정·삭제)는 이 시스템에서 하지 않는다 — 통합표준 9.3절.
 */

function fail(where: string, error: { message: string } | null): void {
  if (error) throw new Error(`${where}: ${error.message}`);
}

export interface BranchRow {
  branchNo: string;
  branchName: string;
}

export async function listBranches(): Promise<BranchRow[]> {
  if (isDevPreview()) return DEV_BRANCHES;

  const client = sb();
  const { data, error } = await client
    .from('branches')
    .select('branch_no, branch_name')
    .order('branch_no', { ascending: true });
  fail('지점 목록 조회', error);

  return (data ?? []).map((r) => ({
    branchNo: r.branch_no as string,
    branchName: r.branch_name as string,
  }));
}

const DEV_BRANCHES: BranchRow[] = [
  { branchNo: '0077', branchName: '김해점' },
  { branchNo: '0101', branchName: '수원점' },
  { branchNo: '0207', branchName: '동탄점' },
];
